import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=4f80da88&scoped=true"
import script from "./PostPage.vue?vue&type=script&lang=js"
export * from "./PostPage.vue?vue&type=script&lang=js"
import style0 from "./PostPage.vue?vue&type=style&index=0&id=4f80da88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80da88",
  null
  
)

export default component.exports